import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../styles.css";
import axios from "axios";
import bcrypt from "bcryptjs";
import { DB_HOST, ENDP_PORT } from "../global_variables";
import { API_IP } from "../global_variables";
import { randomNumber } from "../functions/RandomNumber";

// Format names so that the first letter is upper-case and the rest are lower-case.
function formatName(name) {
  if (!name) return "";

  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

// Registration.js is three pages of registration.
// This is a consistent title for these pages.
const RegistrationTitle = () => (
  <div className="titleContainer">
    <h1>Registration</h1>
  </div>
);

// The first page of registration.
const Registration1 = ({ registrationData, setRegistrationData }) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Updated registration data:", registrationData);
  }, [registrationData]);

  // RegEx variables.
  let nameRegex = /^.{2,}$/;
  let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  let passwordRegex = /^.{2,}$/;
  let hasEmail = false;

  // What to do when the next button is clicked.
  const handleNextButtonClick = async (e) => {
    e.preventDefault();

    let fName = document.getElementById("firstName").value;
    let lName = document.getElementById("lastName").value;
    let email = document.getElementById("email").value;
    let password = document.getElementById("password").value;
    let passwordConfirm = document.getElementById("passwordConfirm").value;
    let isValid = true;

    // Make sure names start with upper-case and the rest are lower-case.
    if (fName != null) fName = formatName(fName);
    if (lName != null) lName = formatName(lName);

    try {
      const url = `${API_IP}/api/accountCheck/?email=${email.toLowerCase()}`;
      const { data } = await axios.get(url);
      hasEmail = data;
      if (hasEmail) {
        document.getElementById("emailExists").style.visibility = "visible";
        isValid = false;
      } else {
        document.getElementById("emailExists").style.visibility = "hidden";
      }
    } catch (error) {
      console.log(error);
    }

    //test if the name is valid
    if (!nameRegex.test(fName)) {
      document.getElementById("firstNameError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("firstNameError").style.visibility = "hidden";
    }

    // test the last name
    if (!nameRegex.test(lName)) {
      document.getElementById("lastNameError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("lastNameError").style.visibility = "hidden";
    }

    // test the email field
    // need to check if the email is at the database
    if (!emailRegex.test(email)) {
      document.getElementById("emailError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("emailError").style.visibility = "hidden";
    }

    //test the password field, regex implies that needs to be longer than 1 character
    if (password === "" || passwordConfirm === "") {
      document.getElementById("samePasswordError").innerText =
        "Password fields cannot be empty";
      document.getElementById("samePasswordError").style.visibility = "visible";
      isValid = false;
    } else if (password !== passwordConfirm) {
      document.getElementById("samePasswordError").innerText =
        "Passwords do not match";
      document.getElementById("samePasswordError").style.visibility = "visible";
      isValid = false;
    } else if (!passwordRegex.test(password)) {
      document.getElementById("passwordError").innerText =
        "Invalid password. It must be longer than 1 character.";
      document.getElementById("passwordError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("samePasswordError").style.visibility = "hidden";
      document.getElementById("passwordError").style.visibility = "hidden";
    }
    console.log(password, 888);
    //do validation later

    if (!isValid) {
      return;
    }

    // Put registration into into a JSON object.
    const registerInfoPart1 = {
      "first-name": fName,
      "last-name": lName,
      email: email,
      password: password,
    };

    setRegistrationData((prevData) => ({
      ...prevData,
      ...registerInfoPart1,
    }));

    // console.log('Step 1 data:', registerInfoPart1);
    // console.log(registrationData);

    navigate("/register/registration2");
  };

  return (
    <form className="inputForm">
      <input
        id="firstName"
        type="text"
        name="first-name"
        placeholder="First Name"
        className="inputText"
      />
      <input
        id="lastName"
        type="text"
        name="last-name"
        placeholder="Last Name"
        className="inputText"
      />
      <input
        id="email"
        type="email"
        name="email-address"
        placeholder="Email Address"
        className="inputText"
      />
      <input
        id="password"
        type="password"
        name="password"
        placeholder="Password"
        className="inputText"
      />
      <input
        id="passwordConfirm"
        type="password"
        name="confirm-password"
        placeholder="Confirm Password"
        className="inputText"
      />
      <div className="progressDisplay">
        <h3>Section 1 / 3</h3>
        <div className="flexRow">
          <p>Have an account?</p>
          <a className="marginLeft" href="/login">
            Log in now
          </a>
        </div>
      </div>
      <ul className="errorOutput">
        <li
          id="firstNameError"
          className="firstNameError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Invalid first name, field cannot be empty
        </li>
        <li
          id="lastNameError"
          className="lastNameError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Invalid last name, field cannot be empty
        </li>
        <li
          id="emailError"
          className="emailError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Invalid email address. format (janedoe@gmail.com)
        </li>
        <li
          id="passwordError"
          className="passwordError"
          style={{ visibility: "hidden", color: "red" }}
        ></li>
        <li
          id="samePasswordError"
          className="samePasswordError"
          style={{ visibility: "hidden", color: "red" }}
        ></li>
        <li
          id="emailExists"
          className="emailExists"
          style={{ visibility: "hidden", color: "red" }}
        >
          Email Already in use, maybe try to log in
        </li>
      </ul>
      <button className="loginButton button" onClick={handleNextButtonClick}>
        Next
      </button>
    </form>
  );
};

// The second page of registration.
const Registration2 = ({ registrationData, setRegistrationData }) => {
  const navigate = useNavigate();

  let phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  let addressRegex = /^[a-zA-Z0-9\s,.'-]{3,}$/;
  let cityRegex = /^[a-zA-Z\s'-]{2,}$/;
  let provinceRegex = /^[a-zA-Z\s'-]{2,}$/;
  let postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

  const handleNextButtonClick = (e) => {
    e.preventDefault();

    let phoneNumber = parseInt(document.getElementById("phoneNumber").value);
    let address = document.getElementById("address").value;
    let address2 = document.getElementById("address2").value;
    let city = document.getElementById("city").value;
    let province = document.getElementById("province").value;
    let postalCode = document.getElementById("postalCode").value;
    let isValid = true;

    if (!phoneRegex.test(phoneNumber)) {
      document.getElementById("phoneFormatError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("phoneFormatError").style.visibility = "hidden";
    }

    // Validate address
    if (!addressRegex.test(address)) {
      document.getElementById("addressFormatError").style.visibility =
        "visible";
      isValid = false;
    } else {
      document.getElementById("addressFormatError").style.visibility = "hidden";
    }

    // Validate city
    if (!cityRegex.test(city)) {
      document.getElementById("cityFormatError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("cityFormatError").style.visibility = "hidden";
    }

    // Validate province
    if (!provinceRegex.test(province)) {
      document.getElementById("provinceFormatError").style.visibility =
        "visible";
      isValid = false;
    } else {
      document.getElementById("provinceFormatError").style.visibility =
        "hidden";
    }

    // Validate postal code
    if (!postalCodeRegex.test(postalCode)) {
      document.getElementById("postalCodeFormatError").style.visibility =
        "visible";
      isValid = false;
    } else {
      document.getElementById("postalCodeFormatError").style.visibility =
        "hidden";
    }

    if (!isValid) {
      return;
    }

    const newRegistrationData = {
      phoneNumber,
      address,
      address2,
      city,
      province,
      postalCode,
    };

    setRegistrationData((prevData) => ({
      ...prevData,
      ...newRegistrationData,
    }));

    console.log("Step 2 data:", newRegistrationData);
    console.log(registrationData);

    navigate("/register/registration3");
  };

  const handleBackButtonClick = () => {
    navigate("/register/registration1");
  };

  return (
    <form className="inputForm">
      <input
        id="phoneNumber"
        type="phone"
        name="phone-number"
        placeholder="Phone Number"
        className="inputText"
      />
      <input
        id="address"
        type="text"
        name="address"
        placeholder="Address"
        className="inputText"
      />
      <input
        id="address2"
        type="text"
        name="address2"
        placeholder="Address 2 (optional)"
        className="inputText"
      />
      <input
        id="city"
        type="text"
        name="city"
        placeholder="City"
        className="inputText"
      />
      <input
        id="province"
        type="text"
        name="province"
        placeholder="Province"
        className="inputText"
      />
      <input
        id="postalCode"
        type="text"
        name="postal-code"
        placeholder="V5K 0A1"
        className="inputText"
      />

      <div className="progressDisplay">
        <h3>Section 2 / 3</h3>
      </div>

      <ul className="errorOutput">
        <li
          id="phoneFormatError"
          className="phoneFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your phone number doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="addressFormatError"
          className="addressFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your address doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="cityFormatError"
          className="cityFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your city doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="provinceFormatError"
          className="provinceFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your province doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="postalCodeFormatError"
          className="postalCodeFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your postal code doesn't appear to be valid. Format V1V 1V1
          <br />
          Please try to enter it again.
        </li>
      </ul>
      <div className="flexRow">
        <button className="loginButton button" onClick={handleBackButtonClick}>
          Back
        </button>
        <button className="loginButton button" onClick={handleNextButtonClick}>
          Next
        </button>
      </div>
    </form>
  );
};

// The third page of registration.
const Registration3 = ({ registrationData }) => {
  const navigate = useNavigate();
  let currentYear = parseInt(new Date().getFullYear());
  let usernameRegex = /^.{2,}$/;
  let isValid = true;
  let hasEmail = false;
  // eslint-disable-next-line no-const-assign

  const handleBackButtonClick = () => {
    navigate("/register/registration2");
  };

  const handleFinishButtonClick = async (e) => {
    e.preventDefault();
    const username = document.getElementById("username").value;

    if (!usernameRegex.test(username)) {
      document.getElementById("usernameError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("usernameError").style.visibility = "hidden";
    }

    try {
      const url = `${API_IP}/api/accountCheck/?email=${username.toLowerCase()}`;
      const { data } = await axios.get(url);
      hasEmail = data;
      if (hasEmail) {
        document.getElementById("usernameExists").style.visibility = "visible";
        isValid = false;
      } else {
        document.getElementById("usernameExists").style.visibility = "hidden";
      }
    } catch (error) {
      console.log(error);
    }

    if (!isValid) {
      return;
    }

    const url = `${API_IP}/api/account`;
    const payload = {
      username: username, // assuming username is defined elsewhere
      email: registrationData.email,
      year: parseInt(currentYear), // assuming currentYear is defined elsewhere
      phone_number: registrationData.phoneNumber,
      password: registrationData.password,
    };

    try {
      const { data } = await axios.post(url, payload);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
    alert(
      "Registration successful! Check your email for verification.\nCheck your spam folder if you don't see it in your inbox."
    );
    navigate("/login");
  };

  return (
    <form className="inputForm">
      <input
        id="username"
        type="text"
        name="username"
        placeholder="Username"
        className="inputText"
      />

      <div className="flexRow">
        <button className="loginButton button" onClick={handleBackButtonClick}>
          Back
        </button>
        <button
          className="loginButton button"
          onClick={handleFinishButtonClick}
        >
          Finish
        </button>
      </div>
      <ul className="errorOutput">
        <li
          id="usernameError"
          className="usernameError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your username doesn't appear to be valid. Cannot be empty
          <br />
          Please try to enter it again.
        </li>
        <li
          id="usernameExists"
          className="usernameExists"
          style={{ visibility: "hidden", color: "red" }}
        >
          Username already in use
        </li>
      </ul>
    </form>
  );
};

// The main component that consolidates and controlls the registration pages.
// If you need to add a page, make a new component for it and add it to the routing table. Make sure to check that Links work.
const Registration = () => {
  const [registrationData, setRegistrationData] = useState({});
  const imageNumber = randomNumber();
  console.log("imageNumber: " + imageNumber);

  return (
    <>
      <div className="contentContainer">
        <div className="registrationFormContainer">
          <RegistrationTitle />

          <Routes>
            <Route
              path="/"
              element={
                <Registration1
                  registrationData={registrationData}
                  setRegistrationData={setRegistrationData}
                />
              }
            />
            <Route
              path="/registration1"
              element={
                <Registration1
                  registrationData={registrationData}
                  setRegistrationData={setRegistrationData}
                />
              }
            />
            <Route
              path="/registration2"
              element={
                <Registration2
                  registrationData={registrationData}
                  setRegistrationData={setRegistrationData}
                />
              }
            />
            <Route
              path="/registration3"
              element={<Registration3 registrationData={registrationData} />}
            />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default Registration;
